import API from './Api'
import { encryptText } from '../helpers/encriptation'

class UserService {
    static Login(username, password) {
        const requestEncrypt = encryptText(JSON.stringify({username, password}));
        return API({
            method: 'POST',
            url: '/auth/login',
            data: { data: requestEncrypt }
        })
    }

    static LoginOtp(otp_code, otp_token) {
        const requestEncrypt = encryptText(JSON.stringify({otp_code, otp_token}));
        return API({
            method: 'POST',
            url: '/auth/login-two-factor',
            data: { data: requestEncrypt }
        })
    }

    static RestorePassword(data) {
        const requestEncrypt = encryptText(JSON.stringify(data));
        return API({
            method: 'PUT',
            url: '/users/password-request',
            data: { data: requestEncrypt }
        })
    }

    static getUser(auth) {
        return API({
            method: 'POST',
            url: '/auth/me',
            headers: auth && { Authorization: `Bearer ${auth}` }
        })
    }

    static logout(auth) {
        return API({
            method: 'POST',
            url: '/auth/logout',
            headers: auth && { Authorization: `Bearer ${auth}` }
        })
    }

    static userInfo(auth) {
        return API({
            method: 'POST',
            url: '/username',
            headers: auth && { Authorization: `Bearer ${auth}` }
        })
    }
}

export default UserService
